// Los rangos de duración (LoR) siguen las mismas reglas en toda la config de
// AutoEurope: enteros entre 1 y 180, `to` nunca por debajo de `from`, y dos rangos
// de la misma lista no pueden solaparse. La lógica vive aquí para que Durations,
// Insurance y los provider overrides validen exactamente igual, y para que coincida
// con lo que acepta el pydantic del webback (`int` + validadores de solape).

export const MIN_DURATION = 1
export const MAX_DURATION = 180

export const OVERLAP_ERROR = "Overlaps with an existing duration range"

const NOT_INTEGER_ERROR = "Whole number"
const OUT_OF_RANGE_ERROR = `${MIN_DURATION}–${MAX_DURATION}`

const isBlank = v => v === "" || v === null || v === undefined

function boundError(value) {
	if (isBlank(value)) return null
	// Number("") es 0, de ahí el isBlank previo. Los decimales se rechazan aquí:
	// el backend tipa la duración como int y descartaría el guardado entero.
	if (!Number.isInteger(Number(value))) return NOT_INTEGER_ERROR
	const n = Number(value)
	return n < MIN_DURATION || n > MAX_DURATION ? OUT_OF_RANGE_ERROR : null
}

// Errores por campo de un par From/To. Un campo vacío no da error: cada bloque
// decide si el rango vacío es válido (override opcional) o no.
export function durationErrors(fromVal, toVal) {
	const from = boundError(fromVal)
	const to = boundError(toVal)
	if (!from && !to && !isBlank(fromVal) && !isBlank(toVal) && Number(toVal) < Number(fromVal)) {
		return { from: null, to: "≥ Dur. From" }
	}
	return { from, to }
}

// Rango completo y usable. Con `required` en false se acepta el par totalmente vacío.
export function isValidDurationRange(fromVal, toVal, required = true) {
	if (isBlank(fromVal) && isBlank(toVal)) return !required
	const { from, to } = durationErrors(fromVal, toVal)
	return !isBlank(fromVal) && !isBlank(toVal) && !from && !to
}

export const rangesOverlap = (aFrom, aTo, bFrom, bTo) => aFrom <= bTo && bFrom <= aTo

// True si [from, to] choca con algún rango ya presente en la lista. `getRange`
// extrae el par del item para las listas que lo anidan (provider overrides).
export function overlapsAny(ranges, from, to, getRange = r => r) {
	return (ranges || []).some(item => {
		const range = getRange(item)
		return range != null
			&& range.durationFrom != null
			&& rangesOverlap(Number(from), Number(to), range.durationFrom, range.durationTo)
	})
}
